"use client";

import { useEffect } from "react";
import { acquirePullToRefreshLock } from "../styles/pull-to-refresh-lock";

/** Desabilita pull-to-refresh enquanto sheet/modal/drawer estiver aberto (ou fechando). */
export function usePullToRefreshLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) {
      return;
    }
    return acquirePullToRefreshLock();
  }, [locked]);
}
